"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNetworkName = getNetworkName;
exports.getEtherscanLink = getEtherscanLink;
exports.getAccountBalance = getAccountBalance;
exports.getERC20Balance = getERC20Balance;
exports.signPersonal = signPersonal;
exports.sendTransaction = sendTransaction;
exports.toDecimal = toDecimal;
exports.fromDecimal = fromDecimal;
exports.TRANSACTION_ERROR_CODES = void 0;

var _ethereumjsUtil = require("ethereumjs-util");

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var networkDataById = {
  1: {
    name: 'Mainnet',
    etherscanPrefix: ''
  },
  3: {
    name: 'Ropsten',
    etherscanPrefix: 'ropsten.'
  },
  4: {
    name: 'Rinkeby',
    etherscanPrefix: 'rinkeby.'
  },
  42: {
    name: 'Kovan',
    etherscanPrefix: 'kovan.'
  }
};
var etherscanTypes = {
  'transaction': 'tx',
  'address': 'address',
  'token': 'token'
};
var ERC20_ABI = [{
  "constant": true,
  "inputs": [{
    "name": "_owner",
    "type": "address"
  }],
  "name": "balanceOf",
  "outputs": [{
    "name": "balance",
    "type": "uint256"
  }],
  "payable": false,
  "stateMutability": "view",
  "type": "function"
}, {
  "constant": true,
  "inputs": [],
  "name": "decimals",
  "outputs": [{
    "name": "",
    "type": "uint8"
  }],
  "payable": false,
  "stateMutability": "view",
  "type": "function"
}]; // eslint-disable-line

var TRANSACTION_ERROR_CODES = ['GAS_PRICE_UNAVAILABLE', 'FAILING_TRANSACTION', 'SENDING_BALANCE_UNAVAILABLE', 'INSUFFICIENT_BALANCE'];
exports.TRANSACTION_ERROR_CODES = TRANSACTION_ERROR_CODES;

function getNetworkName(networkId) {
  if (!Object.keys(networkDataById).includes(String(networkId))) throw Error("networkID '".concat(networkId, "' is invalid."));
  return networkDataById[networkId].name;
}

function getEtherscanLink(networkId, type, data) {
  if (!Object.keys(etherscanTypes).includes(type)) throw Error("type '".concat(type, "' is invalid."));
  if (!Object.keys(networkDataById).includes(String(networkId))) throw Error("networkID '".concat(networkId, "' is invalid."));
  var path = etherscanTypes[type];
  var prefix = networkDataById[networkId].etherscanPrefix;
  return "https://".concat(prefix, "etherscan.io/").concat(path, "/").concat(data);
}

function getAccountBalance(web3js, address) {
  var format = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ether';
  return web3js.eth.getBalance(address).then(function (balance) {
    return web3js.utils.fromWei(balance, format);
  });
}

function getERC20Balance(web3js, ERC20Address, address) {
  var ERC20 = new web3js.eth.Contract(ERC20_ABI, ERC20Address);

  var decimalsPromise = function decimalsPromise() {
    return ERC20.methods.decimals().call();
  };

  var balancePromise = function balancePromise() {
    return ERC20.methods.balanceOf(address).call();
  };

  return Promise.all([decimalsPromise(), balancePromise()]).then(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        decimals = _ref2[0],
        balance = _ref2[1];

    return toDecimal(balance, decimals);
  });
}

function signPersonal(web3js, address, message) {
  if (!(0, _ethereumjsUtil.isValidChecksumAddress)(address)) throw Error("Passed address '".concat(address, "' has an invalid checksum.")); // format message properly

  var encodedMessage;

  if (Buffer.isBuffer(message)) {
    encodedMessage = (0, _ethereumjsUtil.addHexPrefix)(message.toString('hex'));
  } else if (message.slice(0, 2) === '0x') {
    encodedMessage = message;
  } else {
    encodedMessage = (0, _ethereumjsUtil.bufferToHex)(Buffer.from(message, 'utf8'));
  }

  return new Promise(function (resolve, reject) {
    web3js.currentProvider.sendAsync({
      method: 'personal_sign',
      params: [encodedMessage, address],
      from: address
    }, function (error, result) {
      if (error) return reject(error);
      if (result.error) return reject(result.error.message);
      var returnData = {};
      returnData.signature = result.result; // ensure that the signature matches

      var signature = (0, _ethereumjsUtil.fromRpcSig)(returnData.signature);
      var messageHash = (0, _ethereumjsUtil.hashPersonalMessage)((0, _ethereumjsUtil.toBuffer)(encodedMessage));
      var recovered = (0, _ethereumjsUtil.ecrecover)(messageHash, signature.v, signature.r, signature.s);
      var recoveredAddress = (0, _ethereumjsUtil.toChecksumAddress)((0, _ethereumjsUtil.pubToAddress)(recovered).toString('hex'));

      if (recoveredAddress !== address) {
        return reject(Error("The returned signature '".concat(returnData.signature, "' originated from '").concat(recoveredAddress, "', not '").concat(address, "'.")));
      }

      returnData.r = (0, _ethereumjsUtil.addHexPrefix)(signature.r.toString('hex'));
      returnData.s = (0, _ethereumjsUtil.addHexPrefix)(signature.s.toString('hex'));
      returnData.v = signature.v;
      returnData.from = address;
      returnData.messageHash = (0, _ethereumjsUtil.addHexPrefix)(messageHash.toString('hex'));
      resolve(returnData);
    });
  });
}

function sendTransaction(web3js, address, method) {
  var handlers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var transactionOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {}; // sanitize transactionOptions

  var allowedOptions = ['gasPrice', 'gas', 'value'];
  if (!Object.keys(transactionOptions).every(function (option) {
    return allowedOptions.includes(option);
  })) throw Error("Invalid option passed. Allowed options are: '".concat(allowedOptions.toString().join("', '"), "'.")); // sanitize handlers

  var allowedHandlers = ['transactionHash', 'receipt', 'confirmation'];
  if (!Object.keys(handlers).every(function (handler) {
    return allowedHandlers.includes(handler);
  })) throw Error("Invalid handler passed. Allowed handlers are: '".concat(allowedHandlers.toString().join("', '"), "'."));

  for (var _i2 = 0; _i2 < allowedHandlers.length; _i2++) {
    var handler = allowedHandlers[_i2];

    handlers[handler] = handlers[handler] || function () {};
  } // lets us throw specific errors


  function wrapError(error, name) {
    if (!TRANSACTION_ERROR_CODES.includes(name)) return Error("Passed error name ".concat(name, " is not valid."));
    error.code = name;
    return error;
  } // unwrap method if it's a function


  var _method = typeof method === 'function' ? method() : method; // define promises for the variables we need to validate/send the transaction


  var gasPricePromise = function gasPricePromise() {
    if (transactionOptions.gasPrice) return transactionOptions.gasPrice;
    return web3js.eth.getGasPrice().catch(function (error) {
      throw wrapError(error, 'GAS_PRICE_UNAVAILABLE');
    });
  };

  var gasPromise = function gasPromise() {
    return _method.estimateGas({
      from: address,
      gas: transactionOptions.gas
    }).catch(function (error) {
      throw wrapError(error, 'FAILING_TRANSACTION');
    });
  };

  var balanceWeiPromise = function balanceWeiPromise() {
    return getAccountBalance(web3js, address, 'wei').catch(function (error) {
      throw wrapError(error, 'SENDING_BALANCE_UNAVAILABLE');
    });
  };

  return Promise.all([gasPricePromise(), gasPromise(), balanceWeiPromise()]).then(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 3),
        gasPrice = _ref4[0],
        gas = _ref4[1],
        balanceWei = _ref4[2]; // ensure the sender has enough ether to pay gas


    var safeGas = parseInt(gas * 1.1);
    var requiredWei = new _ethereumjsUtil.BN(gasPrice).mul(new _ethereumjsUtil.BN(safeGas));

    if (new _ethereumjsUtil.BN(balanceWei).lt(requiredWei)) {
      var requiredEth = toDecimal(requiredWei.toString(), '18');
      var errorMessage = "Insufficient balance. Ensure you have at least ".concat(requiredEth, " ETH.");
      throw wrapError(Error(errorMessage), 'INSUFFICIENT_BALANCE');
    } // send the transaction


    return _method.send({
      from: address,
      gasPrice: gasPrice,
      gas: safeGas,
      value: transactionOptions.value
    }).on('transactionHash', function (transactionHash) {
      handlers['transactionHash'](transactionHash);
    }).on('receipt', function (receipt) {
      handlers['receipt'](receipt);
    }).on('confirmation', function (confirmationNumber, receipt) {
      handlers['confirmation'](confirmationNumber, receipt);
    });
  });
}

function toDecimal(number, decimals) {
  number = String(number);
  decimals = Number(decimals);

  if (number.length < decimals) {
    number = '0'.repeat(decimals - number.length) + number;
  }

  var difference = number.length - decimals;
  var integer = difference === 0 ? '0' : number.slice(0, difference);
  var fraction = number.slice(difference).replace(/0+$/g, '');
  return integer + (fraction === '' ? '' : '.') + fraction;
}

function fromDecimal(number, decimals) {
  number = String(number);
  decimals = Number(decimals);

  var _number$split = number.split('.'),
      _number$split2 = _slicedToArray(_number$split, 2),
      integer = _number$split2[0],
      fraction = _number$split2[1];

  fraction = fraction === undefined ? '' : fraction;
  if (fraction.length > decimals) throw Error('The fractional amount of the passed number was too high.');
  fraction = fraction + '0'.repeat(decimals - fraction.length);
  return integer + fraction;
}